"use strict";
$(document).ready(function () {
    var modal;
    var modalObject;
    var optionsWrapper;
    var optionsSelectButton;
    var emailWrapper;
    var emailForm;
    var emailSubmitButton;
    var emailCancelButton;
    var appsWrapper;
    var appsForm;
    var appsSubmitButton;
    var appsCancelButton;

    modal = $('#modal_two_factor_authentication');

    if (!modal.length) return;

    // Private functions
    var handleOptionsForm = function () {
        optionsSelectButton.removeClass("d-none");
        optionsSelectButton.on('click', function (e) {
            e.preventDefault();
            var option = optionsWrapper.find('[name="auth_option"]:checked');

            optionsSelectButton.attr('data-indicator', 'on');
            optionsSelectButton.prop('disabled', true);

            $.ajax({
                url: optionsSelectButton.data('link'),
                method: 'POST',
                data: {"option": option.val()},
                success: function (response) {
                    if (response.code === 200) {
                        optionsWrapper.addClass('d-none');

                        if (option.val() === 'email') {
                            emailWrapper.removeClass('d-none');
                        } else {
                            appsWrapper.find("#apps_qr_code").attr("src", response.data.qrBase64);
                            appsWrapper.find("#apps_secret").text(response.data.secret);
                            appsWrapper.removeClass('d-none');
                            appsWrapper.find("input").focus();
                        }
                    } else {
                        showAlert(ALERT_TYPE, {message: response.message, code: response.code});
                    }

                    optionsSelectButton.removeAttr('data-indicator');
                    optionsSelectButton.prop('disabled', false);
                },
                error: function (error) {
                    showAlert(ALERT_TYPE, {message: 'Error during API Sync', code: 400});
                },
            });
        });
    }
    var showOptionsForm = function () {
        optionsWrapper.removeClass('d-none');
        emailWrapper.addClass('d-none');
        appsWrapper.addClass('d-none');
    }
    var handleEmailForm = function () {
        // Handle email submission
        emailSubmitButton.removeClass("d-none")
        emailSubmitButton.on('click', function (e) {
            var emailInput = $(this).closest("form").find("input");

            if (emailInput.val() !== "" && !emailInput.hasClass("error")) {
                emailSubmitButton.attr('data-indicator', 'on');
                emailSubmitButton.prop('disabled', true);

                $.ajax({
                    url: emailSubmitButton.data('link'),
                    method: 'POST',
                    data: {"email": emailInput.val()},
                    success: function (data) {
                        emailSubmitButton.removeAttr('data-indicator');
                        emailSubmitButton.prop('disabled', false);
                        showAlert(ALERT_TYPE, {message: "Email has been successfully submitted!", code: 200});
                        modalObject.hide();
                        showOptionsForm();
                    },
                    error: function (error) {
                        showAlert(ALERT_TYPE, {
                            message: 'Sorry, looks like there are some errors detected, please try again.',
                            code: 400
                        });
                    }
                });
            }
        });

        // Handle email cancellation
        emailCancelButton.on('click', function (e) {
            e.preventDefault();
            var option = optionsWrapper.find('[name="auth_option"]:checked');

            optionsWrapper.removeClass('d-none');
            emailWrapper.addClass('d-none');
        });
    }
    var handleAppsForm = function () {
        // Handle apps submission
        appsSubmitButton.removeClass("d-none")
        appsSubmitButton.on('click', function (e) {
            var appsInput = $(this).closest("form").find("input");

            if (appsInput.val() !== "") {
                appsSubmitButton.attr('data-indicator', 'on');
                appsSubmitButton.prop('disabled', true);

                $.ajax({
                    url: appsSubmitButton.data('link'),
                    method: 'POST',
                    data: {"code": appsInput.val()},
                    success: function (response) {
                        if (response.code == 200) {
                            modalObject.hide();
                            showOptionsForm();

                            window.location.reload();
                        }

                        // showAlert(ALERT_TYPE, response);

                        appsSubmitButton.removeAttr('data-indicator');
                        appsSubmitButton.prop('disabled', false);
                    },
                    error: function (error) {
                        showAlert(ALERT_TYPE, {message: 'Error during API Sync', code: 400});
                    }
                });
            }
        });

        // Handle apps cancellation
        appsCancelButton.on('click', function (e) {
            e.preventDefault();
            var option = optionsWrapper.find('[name="auth_option"]:checked');
            optionsWrapper.removeClass('d-none');
            appsWrapper.addClass('d-none');
            optionsSelectButton.prop('disabled', false);
        });
    }

    modalObject = new bootstrap.Modal(modal[0]);

    optionsWrapper = modal.find('[data-element="options"]');
    optionsSelectButton = modal.find('[data-element="options-select"]');

    emailWrapper = modal.find('[data-element="email"]');
    emailForm = modal.find('form[data-element="email-form"]');
    emailSubmitButton = modal.find('[data-element="email-submit"]');
    emailCancelButton = modal.find('[data-element="email-cancel"]');

    appsWrapper = modal.find('[data-element="apps"]');
    appsForm = modal.find('form[data-element="apps-form"]');
    appsSubmitButton = modal.find('[data-element="apps-submit"]');
    appsCancelButton = modal.find('[data-element="apps-cancel"]');

    // Handle forms
    handleOptionsForm();
    handleEmailForm();
    handleAppsForm();
});
